import translate from "../locales";

export function MoreInfoLink() {
  return (
    <a
      className="link-card link-card--more"
      href={translate(["next", "more_info", "url"])}
      target="_blank"
      rel="noopener noreferrer"
    >
      {translate(["next", "more_info", "label"])}
    </a>
  );
}
